import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isAuthenticated: false,
  email: null,
  role: null,
  token: null,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginAction: (state, action) => {
      const payload = action.payload

      state.isAuthenticated = true
      state.email = payload.data.user.email
      state.role = payload.data.role
      state.token = payload.token
    },
    logoutAction: (state, action) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
})

export const {
  loginAction,
  logoutAction,
} = authSlice.actions
export default authSlice.reducer
